// ─── src/pages/ProjectsPage.jsx ───────────────────────────────────────────
import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
  Tabs,
  Tab,
  useTheme,
  alpha,
} from '@mui/material';
import Masonry from '@mui/lab/Masonry';          //  npm i @mui/lab
import { motion } from 'framer-motion';
import { FaGooglePlay, FaApple, FaGlobe } from 'react-icons/fa';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';

/* ───────────────────── 1.  Raw Data  ──────────────────────────────────── */
const data = {
  android: [
    { title: 'Kirupam',        url: 'https://play.google.com/store/apps/details?id=com.lemda.kirupam1',       desc: 'Multi-region food order app.' },
    { title: 'Kirupam Bridge', url: 'https://play.google.com/store/apps/details?id=com.lemmda.bridge1',      desc: 'Delivery connector.' },
    { title: 'NeuroQuilt',     url: 'https://play.google.com/store/apps/details?id=com.lemda.NeuroQuilt',    desc: 'AI Sudoku challenge.' },
    { title: 'BayEx Driver',   url: 'https://play.google.com/store/apps/details?id=com.lemmda.klimodriverki', desc: 'Partner app for drivers.' },
    { title: 'BayEx Rider',    url: 'https://play.google.com/store/apps/details?id=com.lemda.bayex_riderkir', desc: 'Customer ordering app.' },
    { title: 'BayEx',          url: 'https://play.google.com/store/apps/details?id=com.lemda.Bayexnewki',     desc: 'E-commerce & delivery.' },
    { title: 'Perfect Edu',    url: 'https://play.google.com/store/apps/details?id=com.lemda.perfect_edu_new',desc: 'AI e-learning platform.' },
    { title: 'K LIMO',         url: 'https://play.google.com/store/apps/details?id=com.lemmda.klimo',         desc: 'Chauffeur booking.' },
    { title: 'Al Ikhlas Homeschool', url: 'https://play.google.com/store/apps/details?id=com.lemmda.homeschool', desc: 'Online school.' },
  ],
  ios: [
    { title: 'K LIMO Driver',  url: 'https://apps.apple.com/lk/app/k-limo-driver/id6575362003', desc: 'Drive on your schedule.' },
    { title: 'K LIMO',         url: 'https://apps.apple.com/lk/app/k-limo/id6544791116',        desc: 'Luxury chauffeur.' },
    { title: 'Kirupam Food',   url: 'https://apps.apple.com/lk/app/kirupam/id6464373784',       desc: 'Order food & beverages.' },
    { title: 'Kirupam Bridge', url: 'https://apps.apple.com/lk/app/kirupam-bridge/id1588855254',desc: 'Delivery connector.' },
  ],
  web: [
    { title: 'Kirupam',             url: 'https://kirupam.com/',                  logo: 'https://kirupam.com/logo.png' },
       {
    title: 'VTMMV ALUMNI ASSOCIATION UK',
    url: 'https://mahavidyansuk.org/',
    logo: 'https://mahavidyansuk.org/logo.jpg'
  },
  {
    title: 'Lifeline Community Relief',
    url: 'https://www.lifelinecommunityrelief.org/',
    logo: 'https://www.lifelinecommunityrelief.org/logo.png'
  },
    { title: 'PKMK Construction',   url: 'https://pkmkconstruction.co.uk/',       logo: 'https://pkmkconstruction.co.uk/pkmklogo.png' },
    { title: 'Sai Builders',        url: 'https://saibuilders.co.uk/',            logo: 'https://saibuilders.co.uk/saiblogo.png' },
    { title: 'RichShelf',           url: 'https://richshelf.co.uk/',              logo: 'https://richshelf.co.uk/wp-content/uploads/2024/12/cropped-Rich-shelf-7-600x200.png' },
    { title: 'World Chiller',       url: 'https://worldchiller.co.uk/',           logo: 'https://worldchiller.co.uk/wp-content/uploads/2024/12/WhatsApp-Image-2024-12-31-at-19.29.47-e1735653887841-300x161.jpeg' },
    { title: 'Yoan Wholesale',      url: 'https://yoanwholesale.co.uk/',          logo: 'https://yoanwholesale.co.uk/wp-content/uploads/2025/01/cropped-WhatsApp-Image-2025-01-18-at-16.30.21-1-600x162.jpeg' },
    { title: 'Dubai Shopping',      url: 'https://dubaishopping.lk/',             logo: 'https://dubaishopping.lk/wp-content/uploads/2024/12/DUBAI-tr1-e1678953756420-600x187.png' },
    { title: 'Al Rahman Int’l',     url: 'https://alrahmaninternational.co.uk/',  logo: 'https://alrahmaninternational.co.uk/admin/uploads/AL%20Rahman%20international%20(2).png' },
    { title: 'KRS Cake City',       url: 'https://krscakecity.com/',              logo: 'https://krscakecity.com/static/media/logo.0ef3424daee6029d601b.png' },
    { title: 'Ranjan & Co',        url: 'https://ranjanandco.com/',              logo: 'https://ranjanandco.com/logos/WhatsApp%20Image%202025-06-09%20at%204.39.54%20PM.jpeg' },
    { title: 'DEST',                url: 'https://dest.lk/',                      logo: 'https://dest.lk/wp-content/uploads/2022/01/cropped-Logo2-removebg-preview-300x100.png' },
    
  ],
};

/* ───────────────────── 2.  Helpers  ───────────────────────────────────── */
const categories = [
  { key: 'android', label: 'Android', Icon: FaGooglePlay },
  { key: 'ios',     label: 'iOS',     Icon: FaApple      },
  { key: 'web',     label: 'Web',     Icon: FaGlobe      },
];

function ProjectCard({ project, category }) {
  const theme  = useTheme();
  const glowBg = alpha(theme.palette.primary.main, 0.08);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
    >
      <Card
        sx={{
          height: '100%',
          borderRadius: 3,
          overflow: 'hidden',
          boxShadow: 3,
          bgcolor: glowBg,
          transition: '0.3s',
          '&:hover': { boxShadow: 6, transform: 'translateY(-4px)' },
        }}
      >
        {category === 'web' ? (
          <CardMedia
            component="img"
            image={project.logo}
            alt={project.title}
            sx={{ height: 140, p: 2, objectFit: 'contain' }}
          />
        ) : (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 140,
              bgcolor: theme.palette.primary.light,
            }}
          >
            {category === 'android' && <FaGooglePlay size={40} />}
            {category === 'ios'      && <FaApple      size={40} />}
          </Box>
        )}

        <CardContent sx={{ flexGrow: 1 }}>
          <Typography variant="h6" fontWeight={700} gutterBottom>
            {project.title}
          </Typography>
          {project.desc && (
            <Typography variant="body2" color="text.secondary">
              {project.desc}
            </Typography>
          )}
        </CardContent>

        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Button
            fullWidth
            component="a"
            href={project.url}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            color={category === 'web' ? 'info' : 'primary'}
            sx={{ textTransform: 'none' }}
          >
            {category === 'web'
              ? 'Visit Website'
              : `View on ${category === 'android' ? 'Play Store' : 'App Store'}`}
          </Button>
        </Box>
      </Card>
    </motion.div>
  );
}

/* ───────────────────── 3.  Page  ──────────────────────────────────────── */
export default function ProjectsPage() {
  const [tab, setTab] = useState('android');

  return (
    <>
      {/* <Navbar /> */}

      {/* Hero */}
      <Box
        sx={{
          py: { xs: 6, md: 10 },
          textAlign: 'center',
          background: (t) =>
            `linear-gradient(135deg, ${alpha(t.palette.primary.main, 0.06)} 0%, ${alpha(
              t.palette.primary.light,
              0.06
            )} 100%)`,
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h4" fontWeight={700} gutterBottom>
            Our Projects
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4 }}>
            Explore our latest mobile apps and web platforms, built end-to-end
            with cutting-edge tech and flawless UX.
          </Typography>

          {/* Category Tabs */}
          <Tabs
            value={tab}
            onChange={(_e, v) => setTab(v)}
            centered
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              mb: 4,
              '& .MuiTab-root': { textTransform: 'none', fontWeight: 600 },
            }}
          >
            {categories.map(({ key, label, Icon }) => (
              <Tab
                key={key}
                value={key}
                icon={<Icon size={18} style={{ marginRight: 6 }} />}
                label={label}
              />
            ))}
          </Tabs>
        </Container>
      </Box>

      {/* Masonry Grid */}
      <Container sx={{ py: { xs: 4, md: 6 } }}>
        <Masonry
          columns={{ xs: 1, sm: 2, md: 3, lg: 4 }}
          spacing={3}
          defaultColumns={3}
        >
          {data[tab].map((proj, i) => (
            <ProjectCard key={i} project={proj} category={tab} />
          ))}
        </Masonry>
      </Container>

      {/* <Footer /> */}
    </>
  );
}
